module.exports = __webpack_public_path__ + "static/img/analytics_dark.36f97245.svg";